import * as memberData from '../services/memberData';

export default {
  namespace: 'memberData',

  state: {
    memberDataList: {},
    memberDataOrderRecords: [],
    memberDataGiftRecords: [],
    memberDataDgTags: [],
    memberDataDetails: {},
  },

  effects: {
    *getMemberDataList({ payload: { values } }, { call, put }) {
      const response = yield call(memberData.getMemberDataList, values);
      yield put({
        type: 'save',
        payload: {
          memberDataList: response?.data,
        },
      });
    },
    *getMemberDetailData({ payload: { values } }, { all, call, put }) {
      const [memberDataOrderRecords, memberDataGiftRecords, memberDataDgTags] =
        yield all([
          call(memberData.getMemberDataOrderRecords, values),
          call(memberData.getMemberDataGiftRecords, values),
          call(memberData.getMemberDataDgTags, values),
        ]);
      yield put({
        type: 'save',
        payload: {
          memberDataOrderRecords: memberDataOrderRecords.data,
          memberDataGiftRecords: memberDataGiftRecords.data,
          memberDataDgTags: memberDataDgTags.data,
        },
      });
    },
    *getMemberDataDetails({ payload: { values } }, { call, put }) {
      const response = yield call(memberData.getMemberDataDetails, values);
      yield put({
        type: 'save',
        payload: {
          memberDataDetails: response?.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
    delete(state) {
      return {
        ...state,
        memberDataDetails: {},
      };
    },
  },

  subscriptions: {},
  setup({ history, dispatch }) {
    return history.listen((props) => {
      if (props.pathname?.includes('member-data?')) {
        dispatch({
          type: 'memberData/delete',
        });
      }
    });
  },
};
